module.exports = __webpack_public_path__ + "static/nginx-21951e5fe0771bc2c2725b6f35459d96.png";